export default abstract class BaseStore {
  /** Returns a plain serializable JSON version of the store */
  toJSON(): Record<string, any> {
    const data: Record<string, any> = {}

    for (const key of Object.getOwnPropertyNames(this)) {
      const value = (this as any)[key]

      if (typeof value !== 'function') {
        data[key] = value
      }
    }

    return data
  }

  /** Hydrates a store instance from JSON */
  fromJSON(data: Record<string, any>): void {
    Object.entries(data).forEach(([key, value]) => {
      if (key in this) {
        ;(this as any)[key] = value
      }
    })
  }
}
